import axios from 'axios';
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from "../../../Store";
import getDiscountSlabs from "./discount_gets";

function _success(success) {
    return {type: 'DELETE_DISCOUNT_SUCCESS', success}
}

function _error(error) {
    return {type: 'DELETE_DISCOUNT_ERROR', error}
}

function _processing(processing) {
    return {type: 'DELETE_DISCOUNT_PROCESSING', processing}
}

function deleteDiscount(id) {
    return (dispatch) => {

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let config = {
            headers: {'Authorization': 'Bearer ' + loginToken()},
        };

        axios.delete(apiBaseUrl(`admin/discount_slabs/${id}`), config)

            .then(res => {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res);
                store.dispatch(getDiscountSlabs());
            }).catch(error => {
            dispatch(_error(error));
            dispatch(_processing(false));
            handleError(error)

        });
    }
}

export default deleteDiscount;